import * as React from 'react';
import {InjectedFormProps, reduxForm} from 'redux-form';
import {Forms} from '../../../shared/models/forms';
import {SearchBarForm} from './model';
import SearchBarView from './SearchBarView';

const _SearchBar: React.FC<InjectedFormProps<SearchBarForm>> = () => {
  return <SearchBarView />;
};

export const SearchBar = reduxForm<SearchBarForm>({form: Forms.searchBarForm})(_SearchBar);
